import { render, staticRenderFns } from "./airlines.vue?vue&type=template&id=f74800e4&"
import script from "./airlines.vue?vue&type=script&lang=js&"
export * from "./airlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports